{{#if label}}
  <label for="{{id}}">{{t label}}</label>
{{/if}}
<div class="btn-group {{class}}" data-toggle="buttons">
  {{#each options}}
    <label class="btn btn-default">
      <label for="{{id}}">{{t text}}</label>
      <input type="radio" id="{{id}}" name="{{../id}}" {{#if default_value}}checked{{/if}} {{#if attributes}}data-attributable{{/if}} />
    </label>
  {{/each}}
</div>
